import React from 'react';
import { MotionLink, MotionCard, FadeInSection } from '../ui/MotionPrimitives';

const ServicesHero: React.FC = () => {
  return (
    <FadeInSection className="w-full bg-black pb-20 pt-28 md:pt-32 lg:pt-40 lg:pb-24 min-h-[520px] md:min-h-[580px]">
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-6 md:px-10 lg:flex-row lg:items-center">
        <div className="w-full lg:w-7/12">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[rgb(216,133,70)]">
            Services
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
            End-to-end real estate investment & advisory.
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/80 sm:text-base">
            From opportunity sourcing to long-term portfolio management, we support investors
            across every stage of the real estate lifecycle in the UAE and USA.
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-4">
            <MotionLink
              to="/contact"
              className="inline-flex items-center rounded-full bg-[rgb(216,133,70)] px-8 py-3 text-sm font-semibold uppercase tracking-wide text-black shadow-md transition hover:bg-[#c1733d] focus:outline-none focus:ring-2 focus:ring-[rgb(216,133,70)] focus:ring-offset-2 focus:ring-offset-black"
            >
              Talk to our team
            </MotionLink>
          </div>
        </div>

        <div className="w-full lg:w-5/12">
          <div className="grid gap-5 sm:grid-cols-2">
            <MotionCard className="rounded-2xl border border-white/10 bg-white/5 p-6 text-base text-white min-h-[150px]">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/70">
                UAE & USA
              </p>
              <p className="mt-3 text-lg font-semibold">Dual-market expertise</p>
            </MotionCard>
            <MotionCard className="rounded-2xl border border-white/10 bg-white/5 p-6 text-base text-white min-h-[150px]">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/70">
                Investors
              </p>
              <p className="mt-3 text-lg font-semibold">Partnership-first approach</p>
            </MotionCard>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default ServicesHero;
